import { FocusEventHandler, useState } from 'react';

import { UseFocus } from './types';

const noop: FocusEventHandler<HTMLInputElement> = (event) => {};

export const useFocus: UseFocus = ({
  onFocus: _onFocus = noop,
  onBlur: _onBlur = noop,
} = {}) => {
  const [focus, setFocus] = useState(false);

  return {
    focus,
    onFocus(event) {
      setFocus(true);
      _onFocus(event);
    },
    onBlur(event) {
      setFocus(false);
      _onBlur(event);
    },
  };
};
